import React from 'react';

import { SVGIconProps } from '@/models/';

export default (props: SVGIconProps) => {
  const newProps = { ...props };
  delete newProps.alt;
  delete newProps.title;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...newProps} role="img">
      {props.title && <title>{props.title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.669 1.25671C12.2887 0.914431 11.7114 0.914431 11.331 1.25671L1.33105 10.2567C1.02328 10.5337 0.918051 10.9717 1.06639 11.3583C1.21473 11.7448 1.58596 12 2.00001 12H5L5 21H2C1.44772 21 1 21.4477 1 22C1 22.5523 1.44772 23 2 23L22 23C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21H19V12H22C22.4141 12 22.7853 11.7448 22.9336 11.3583C23.082 10.9717 22.9767 10.5337 22.669 10.2567L12.669 1.25671ZM17 12H15V21H17V12ZM13 12H11V21H13V12ZM9 12H7L7 21H9V12Z"
      />
    </svg>
  );
};
